var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.store = {
	initProduct: function () {
		site.owl.init('.product .albumImages', {
			loop: false,
			dots: false,
			nav: true,
			items: 4,
			navText: ["", ""],
			margin: 10,
			responsive: {
				0: {
					items: 2
				},
				480: {
					items: 4
				}
			}
		});
	},

	initSelect: function() {
		//Checkout
		if ($('body').hasClass('checkout')) {
			$('#billing-billingSameAsShipping').change(function() {
				var $fieldset = $('#fieldset-billing').toggleClass('disabled');
				if ($fieldset.hasClass('disabled')) {
					$fieldset.find('input:not(.checkbox)').attr('disabled', 'disabled');
				}
				else {
					$fieldset.find('input:not(.checkbox)').attr('disabled', null);
				}
			}).change();

			$('ul.paymentTypeSelection li').click(function(){
				$(this).siblings().removeClass('selected');
				$(this).addClass('selected');
			});
		}
	}
};

store = window.store || {};
store.local = store.local || {};
store.local.onUpdateVariantData = function(variant) {
	var attributes = '';
	$.each(variant.attributes, function(attrIdx, attr) {
		attributes += attr + ' / ';
	});
	attributes = attributes.substr(0, attributes.length - 3);

	$('.product .attributes').html(attributes);
};

store.local.updateMiniCart = function() {
	$.get(store.url(store.action.cartBox, ''), function (data) {
		$('.miniCart').replaceWith(data.html);
	}, 'json');
};

store.local.onAddToCart = function() {
	store.local.updateMiniCart();
};

store.local.onCartIncrease = function() {
	store.local.updateMiniCart();
};

store.local.onCartDecrease = function() {
	store.local.updateMiniCart();
};

store.local.initAlbumImages = function() {
	$('ul.albumImages a').click(function(e) {
		e.preventDefault();
		$href = $(this).attr('href');
		$src = $(this).data('image');
		$image = $('.images .image');

		if ($src != $('img', $image).attr('src')) {
			$image.append('<div class="loading">')
			$('a', $image).attr("href", $href);
			$('img', $image).attr("src", $src).load(function() {
				$('.loading',$image).remove();
			});
		}
	});
};

store.local.initPaymentSelection = function () {
	$('input[name="paymentType"]:checked').each(function() {
		$(this).closest('li').addClass('selected');
	});

	$('#billing-billingSameAsShipping').change(function() {
		var $fieldset = $('#fieldset-billing').toggleClass('disabled');
		if ($fieldset.hasClass('disabled')) {
			$fieldset.find('input:not(.checkbox)').attr('disabled', 'disabled');
		}
		else {
			$fieldset.find('input:not(.checkbox)').attr('disabled', null);
		}
	}).change();

	$('ul.paymentTypeSelection li').click(function(){
		$(this).siblings().removeClass('selected');
		$(this).addClass('selected');
	});
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
